import { useEffect } from 'react';
import socketConnection from 'components/SocketConnection';
import SocketChannels from '../../../../../socket_server/SocketChannels';

// While the user has a current match, the site socket gets its match pushes
// on every page and counts the user online in matchmaking: the dock lets them
// follow and play the match from anywhere. Released when the match closes.
export const MATCH_DOCK_CHANNELS = Object.freeze({ channels: [SocketChannels.MATCH], presence: true });

export default function useMatchChannel(inMatch) {
	useEffect(() => {
		if(!inMatch) {
			return undefined;
		}
		return socketConnection.claimChannels(MATCH_DOCK_CHANNELS);
	}, [inMatch]);
}
